import { Box, Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import TotalEwaDisbursementPastChart from './TotalEwaDisbursementPastChart'
import dayjs from 'dayjs'
import { useSearchParams } from 'react-router-dom'

export const TotalEWADisbursement = ({ data, dataMonth }: { data: any; dataMonth: any }) => {
  const { __, __n } = useTranslator()
  const [searchParams] = useSearchParams()
  const monthParam = searchParams.get('month')
  const activeMonthIndex = monthParam ? dayjs(monthParam).month() + 1 : 0

  const chartData = data
    ? Object.entries(data).reduce((acc: Record<string, { debt: number; collected: number }>, [key, value]) => {
        const v = value as { balance?: { debt?: number; collected?: number } }

        acc[`${key}`] = {
          debt: v.balance?.debt || 0,
          collected: v.balance?.collected || 0
        }

        return acc
      }, {})
    : {}

  return (
    <Card className='rounded-[16px]'>
      <CardContent className='p-6'>
        <div className='flex flex-col gap-2'>
          <div className='flex flex-row gap-2 items-center'>
            <Box className='rounded-[6px] bg-[#DDF6E8] p-2 flex items-center '>
              <i className='tabler-checkup-list text-[#28C76F]'></i>
            </Box>
            <Typography className='text-[18px] font-medium leading-[28px]'>{__('Total EWA Disbursement')}</Typography>
          </div>
          <div className='flex gap-2 items-center'>
            <Typography className='text-[38px] font-medium leading-[56px]'>
              {__n(dataMonth?.request_amount, 'đ')}
            </Typography>
            {dataMonth?.lift_paid !== 0 && (
              <div className='rounded-[20px] h-[30px] text-[13px] bg-[#E8E6FC] shadow-none text-[#3551F2] font-medium flex justify-center items-center py-[6px] px-[14px]'>
                {__n(dataMonth?.lift_paid, 'đ')}
              </div>
            )}
          </div>
        </div>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 5 }}>
            <div className='flex justify-between items-center'>
              <div className='flex flex-row gap-2 items-center'>
                <i className='tabler-cash-banknote-off ' />
                <Typography className='text-[15px] font-medium leading-[22px]'>{__('Collected')}</Typography>
              </div>
              <Typography className='text-[15px] font-medium leading-[22px]'>
                {dataMonth?.collected
                  ? __n(dataMonth?.collected, 'đ')
                  : __n(chartData?.[String(activeMonthIndex)]?.collected || 0, 'đ')}
              </Typography>
            </div>
          </Grid>
          <Divider orientation='vertical' flexItem className='mx-[24px]' />
          <Grid size={{ xs: 12, md: 5 }}>
            <div className='flex justify-between items-center'>
              <div className='flex flex-row gap-2 items-center'>
                <i className='tabler-cash-banknote-off ' />
                <Typography className='text-[15px] font-medium leading-[22px]'>{__('Debt')}</Typography>
              </div>
              <Typography className='text-[15px] font-medium leading-[22px]'>
                {dataMonth?.debt ? __n(dataMonth?.debt, 'đ') : __n(chartData?.[String(activeMonthIndex)]?.debt || 0, 'đ')}
              </Typography>
            </div>
          </Grid>
        </Grid>

        {/* Chart Total EWA Disbursement Past Month */}
        <TotalEwaDisbursementPastChart className='h-[230px]' data={chartData} />
      </CardContent>
    </Card>
  )
}
